module.exports = __webpack_public_path__ + "static/media/delete-icon.cb6e45fe.svg";